<template>
  <el-form
    :model="form"
    :disabled="disabledForm"
    ref="form">
    <!-- Supplier Quote -->
    <el-row :gutter="24">
      <el-col :lg="4" :md="5" :sm="6" :span="12">
        <el-form-item
          prop="chosen"
          class="material-style margin-bottom-none"
        >
          <el-checkbox
            v-model="form.chosen"
            @change="autoSave('chosen')"
          >{{L10n('include-in-po')}}</el-checkbox>
        </el-form-item>
      </el-col>
      <el-col :lg="2" :md="3" :sm="6" :span="12">
        <el-form-item
          :label="L10n('qty')"
          :rules="getValidationRule('required,numberInteger')"
          prop="qty"
          class="material-style">
          <el-input
            :value="form.qty"
            @input="form.qty = valueNumber($event)"
            @change="autoSave('qty', { required: true })"
          />
        </el-form-item>
      </el-col>
      <el-col :lg="5" :md="8" :sm="12" :span="12">
        <el-form-item
          :label="L10n('part-number')"
          prop="partID"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <select-part-number
            :model.sync="form.partID"
            disabled
          ></select-part-number>
        </el-form-item>
      </el-col>
      <el-col :lg="4" :md="8" :sm="12" :span="12">
        <el-form-item
          :label="L10n('S/N')"
          prop="partSN"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <el-input
            v-model="form.partSN"
            @change="autoSave('partSN', { required: true })"
          />
        </el-form-item>
      </el-col>
      <el-col :lg="2" :md="8" :sm="12" :span="24">
        <el-form-item
          :label="L10n('price')"
          prop="price"
          class="material-style"
          :rules="getValidationRule('required,number')"
        >
          <el-input
            :value="form.price"
            @input="form.price = valueNumber($event)"
            @change="autoSave('price', { required: true })"
          />
        </el-form-item>
      </el-col>
      <el-col :lg="3" :md="8" :sm="12" :span="24">
        <el-form-item
          prop="currencyID"
          :label="L10n('currency')"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <select-response
            :model.sync="form.currencyID"
            @update:model="autoSave('currencyID', { required: true })"
            :isLoading="dataSourceCurrency.loading"
            :data="dataSourceCurrency.records"
          ></select-response>
        </el-form-item>
      </el-col>
      <el-col :lg="4" :md="8" :sm="12" :span="24">
        <el-form-item
          :label="L10n('condition')"
          prop="conditionID"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <select-response
            :model.sync="form.conditionID"
            @update:model="autoSave('conditionID', { required: true })"
            :isLoading="dataSourceCondition.loading"
            :data="dataSourceCondition.records"
          ></select-response>
        </el-form-item>
      </el-col>
    </el-row>
    <view-more :isApply="!isNew">
      <div class="row">
        <div class="col-xl-2 col-lg-4 col-md-6 col-12">
          <el-form-item
            :label="L10n('release')"
            prop="releaseID"
            class="material-style"
          >
            <select-response
              :model.sync="form.releaseID"
              @on-change="autoSave('releaseID')"
              :data="dataSourceRelease.records"
              :isLoading="dataSourceRelease.loading"
            ></select-response>
          </el-form-item>
        </div>
        <div class="col-xl-2 col-lg-4 col-md-6 col-12">
          <el-form-item
            :label="L10n('tag-info-company')"
            prop="tagInfoCompanyID"
            class="material-style"
          >
            <select-company
              :model.sync="form.tagInfoCompanyID"
              @on-change="autoSave('tagInfoCompanyID')"
              :disabled="disabledForm"
            >
            </select-company>
          </el-form-item>
        </div>
        <div class="col-xl-2 col-lg-4 col-md-6 col-12">
          <el-form-item
            :label="L10n('traceability-company')"
            prop="traceabilityCompanyID"
            class="material-style"
          >
            <select-company
              :model.sync="form.traceabilityCompanyID"
              @on-change="autoSave('traceabilityCompanyID')"
              :disabled="disabledForm"
            >
            </select-company>
          </el-form-item>
        </div>
        <div class="col-xl-2 col-lg-4 col-md-6 col-12">
          <el-form-item
            :label="L10n('tag-date')"
            prop="tagDate"
            class="material-style">
            <date-picker
              v-model="form.tagDate"
              @change="autoSave('tagDate')"/>
          </el-form-item>
        </div>
        <div class="col-xl-2 col-lg-4 col-md-6 col-12">
          <el-form-item
            :label="L10n('supply-date')"
            prop="supplyDate"
            class="material-style"
          >
            <el-input
              v-model="form.supplyDate"
              @change="autoSave('supplyDate')"
            />
          </el-form-item>
        </div>
        <div class="col-xl-2 col-lg-4 col-md-6 col-12">
          <el-form-item
            :label="L10n('stock')"
            prop="stockID"
            class="material-style"
          >
            <select-response-auto-complete
              :model.sync="form.stockID"
              @on-change="autoSave('stockID')"
              searchAllColumns
              :columns="stockColumns"
              api="Stocks/GetAllDynamic"
              selected="id,supplierCompany.name as supplierCompanyName,partPrice,priceCurrency.title as priceCurrencyTitle,ownerCompany.name as ownerCompanyName,condition.title as conditionTitle"
              :fields="{id: 'id', title: 'supplierCompanyName'}"
              :orderBy="{ fields: 'supplierCompany.name', order: 'desc'}"
            >
            </select-response-auto-complete>
          </el-form-item>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-4 col-lg-4 col-md-6 col-12">
          <el-form-item
            :label="L10n('exchange-core-value')"
            prop="exchangeCoreValue"
            class="material-style"
            :rules="getValidationRule('number')"
          >
            <el-input
              :value="form.exchangeCoreValue"
              @input="form.exchangeCoreValue = valueNumber($event)"
              @change="autoSave('exchangeCoreValue', { required: false })"
            />
          </el-form-item>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-12">
          <el-form-item
            :label="L10n('currency')"
            prop="exchangeCoreValueCurrencyID"
            class="material-style"
          >
            <select-response
              :model.sync="form.exchangeCoreValueCurrencyID"
              @on-change="autoSave('exchangeCoreValueCurrencyID')"
              :isLoading="dataSourceCurrency.loading"
              :data="dataSourceCurrency.records"
            ></select-response>
          </el-form-item>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-6 col-12">
          <el-form-item
            :label="L10n('exchange-condition')"
            prop="exchangeConditionID"
            class="material-style"
          >
            <select-response
              :model.sync="form.exchangeConditionID"
              @on-change="autoSave('exchangeConditionID')"
              :isLoading="dataSourceCondition.loading"
              :data="dataSourceCondition.records"
            ></select-response>
          </el-form-item>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-2 col-lg-4 col-md-6 col-12">
          <el-form-item
            :label="L10n('core-due-date')"
            prop="coreDueDate"
            class="material-style">
            <date-picker
              v-model="form.coreDueDate"
              @change="autoSave('coreDueDate')"/>
          </el-form-item>
        </div>
        <div class="col-xl-2 col-lg-4 col-md-6 col-12">
          <el-form-item
            :label="L10n('quote-date')"
            prop="quoteDate"
            class="material-style">
            <date-picker
              v-model="form.quoteDate"
              @change="autoSave('quoteDate')"/>
          </el-form-item>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-6 col-12">
          <el-form-item
            :label="L10n('remarks')"
            prop="remarks"
            class="material-style">
            <el-input
              :value="form.remarks"
              @input="form.remarks = valueTrimLeft($event)"
              @change="autoSave('remarks')"/>
          </el-form-item>
        </div>
        <div class="col-lg-auto col-md-6 col-12">
          <el-form-item
            prop="exchangeCoreReceived"
            class="material-style"
          >
            <el-checkbox
              v-model="form.exchangeCoreReceived"
              @change="autoSave('exchangeCoreReceived')"
            >{{L10n('exchange-core-received')}}</el-checkbox>
          </el-form-item>
        </div>
        <div class="col-lg-auto col-md-6 col-12">
          <el-form-item
            prop="sendMail"
            class="material-style"
          >
            <el-checkbox
              v-model="form.sendMail"
              @change="autoSave('sendMail')"
            >{{L10n('send-mail')}}</el-checkbox>
          </el-form-item>
        </div>
      </div>
      <form-controls
        v-if="!isNew"
        :isSave="!disabled"
        :isDelete="!disabled"
        @command="handlerCommand"
      ></form-controls>
    </view-more>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'
import mixListForm from '@/components/ListForm/mixForm'
export default {
  name: 'FormSupplierQuoteRFQ',
  mixins: [mixListForm, Form],
  components: {
    'view-more': () => import(/* webpackChunkName: 'UI' */ '@/components/UI/ViewMore.vue'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls'),
    'select-part-number': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectPartNumber/Index.vue'),
    'select-company': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompany/Index.vue')
  },
  props: {
    isNew: { type: Boolean, required: true }
  },
  created () {
    this.$bus.$onPromise('validate-to-create-po', this.customValidate)
  },
  beforeDestroy () {
    this.$bus.$offPromise('validate-to-create-po', this.customValidate)
  },
  computed: {
    dataSourceCurrency () {
      return this.API('Currencies/GetAllDynamic?select=id,title')
    },
    dataSourceCondition () {
      return this.API('Conditions/GetAllDynamic?select=id,title&orderBy=title asc')
    },
    dataSourceRelease () {
      return this.API('Releases/GetAllDynamic?select=id,title')
    },
    stockColumns () {
      return [
        { title: this.L10n('supplier-company'), value: 'supplierCompanyName', type: 'string', originField: 'supplierCompany.name' },
        {
          title: this.L10n('price'),
          // eslint-disable-next-line
          template: "${data.partPrice ? data.partPrice: ''} ${data.priceCurrencyTitle ? data.priceCurrencyTitle: ''}",
          type: 'number',
          originField: 'partPrice'
        },
        { title: this.L10n('owner-company'), value: 'ownerCompanyName', type: 'string', originField: 'ownerCompany.name' },
        { title: this.L10n('condition'), value: 'conditionTitle', type: 'string', originField: 'condition.title' }
      ]
    }
  },
  methods: {
    async customValidate () {
      if (this.form.chosen) {
        return this.validate()
      }
      return true
    },
    handlerCommand (command) {
      this.$emit('command', command)
    }
  }
}
</script>
